"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcAvailablePeirods = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const __1 = require("..");
const helpers_1 = require("./helpers");
const businessDaysLatereCanBeBookedFilter_1 = require("./helpers/businessDaysLatereCanBeBookedFilter");
const daysLaterCanBeBookedFilter_1 = require("./helpers/daysLaterCanBeBookedFilter");
const toDayAvailabilities_1 = require("./helpers/toDayAvailabilities");
const calcAvailablePeirods = (params, type, bookerPeriodsData, userPeriodsDatum, roomAvailablePeriods, candidatePeriods, nationalHolidays) => {
    const { formula, lengthMin, dateTimeRange, daysLaterCanBeBooked } = params;
    // 各ユーザーの空き予定にフィルターをかける
    const userAvailablePeriods = Object.entries(userPeriodsDatum).reduce((acc, [uid, data]) => {
        acc[uid] = calcUserAvailablePeriods(data, params);
        return acc;
    }, {});
    // 各式の空き時間を計算
    const eachFormulaAvailablePeriods = __1.FormulaAvailablePeriodsCalculator.calc(JSON.parse(formula), userAvailablePeriods);
    // 全体のAvailablePeriods
    let availablePeriods = Object.values(eachFormulaAvailablePeriods).reduce((acc, currentValue) => acc.or(currentValue, lengthMin));
    // 仲介の場合は、ユーザーの予定は考慮しない
    if (type === 'tpb') {
        availablePeriods = new __1.Periods([
            new __1.Period(new Date(), (0, date_fns_1.addMonths)(new Date(), 3))
        ]);
    }
    // または調整で代表者が含まれていない場合のために曜日と日付のフィルターを適用する
    if ((dateTimeRange === null || dateTimeRange === void 0 ? void 0 : dateTimeRange.type) === 'dayOfWeek') {
        availablePeriods = (0, helpers_1.dayOfWeekFilter)(dateTimeRange, availablePeriods, nationalHolidays);
    }
    // booker
    if (bookerPeriodsData) {
        availablePeriods = (0, helpers_1.bookerFilter)(availablePeriods, bookerPeriodsData);
    }
    // room
    if (!(0, lodash_1.isEmpty)(roomAvailablePeriods)) {
        availablePeriods = (0, helpers_1.roomFilter)(availablePeriods, roomAvailablePeriods, lengthMin);
    }
    // candidatePeriodsがある場合はand演算
    if (candidatePeriods) {
        availablePeriods = availablePeriods.and(candidatePeriods);
    }
    if (daysLaterCanBeBooked) {
        if (daysLaterCanBeBooked.isBusinessDaysConsidered) {
            // X営業日後
            availablePeriods = (0, businessDaysLatereCanBeBookedFilter_1.businessDaysLaterCanBeBookedFilter)(availablePeriods, daysLaterCanBeBooked, 
            // 何日後から予約可能かを指定してる時点で、日付選択はできないので、FSRangeByDayOfWeekに決まる
            (0, toDayAvailabilities_1.toDayAvailabilities)(dateTimeRange.hours), nationalHolidays);
        }
        else {
            // X日後
            availablePeriods = (0, daysLaterCanBeBookedFilter_1.daysLaterCanBeBookedFilter)(availablePeriods, daysLaterCanBeBooked);
        }
    }
    // 日付のフィルター
    // 全体にかけておけば、この中からしか選べないのでOR調整に影響を与えることもないはず
    availablePeriods = (0, helpers_1.dateTimeRangeFilter)(availablePeriods, dateTimeRange, nationalHolidays);
    // 打ち合わせ時間未満の削除
    availablePeriods = availablePeriods.excludeLessThanMinutes(lengthMin);
    // 日を跨ぐPeriodsを分割
    availablePeriods = (0, __1.divideOverDayPeriodFilter)(availablePeriods);
    return {
        eachFormulaAvailablePeriods,
        availablePeriods
    };
};
exports.calcAvailablePeirods = calcAvailablePeirods;
/**
 * ユーザーごとの空き予定を算出する
 * @param userPeriodsData
 * @returns
 */
const calcUserAvailablePeriods = (userPeriodsData, { lengthMin, dateTimeRange, buffer }) => {
    // NOTE: 業務時間より先にバッファーをかける必要
    let periods = (0, __1.bufferFilter)(userPeriodsData.availablePeriods, buffer !== null && buffer !== void 0 ? buffer : 0);
    // 日を跨ぐPeriodsを分割
    // (クライアントのタイムゾーンで分割する必要があるので、フロントで実行する必要がある)
    periods = (0, __1.divideOverDayPeriodFilter)(periods);
    // 打ち合わせ時間未満の削除
    periods = periods.excludeLessThanMinutes(lengthMin);
    // ゲストで業務時間を考慮するフラグが立ってる場合は業務時間でAndをかける
    if (userPeriodsData.type === 'user' &&
        !userPeriodsData.isOwner && // オーナーの場合は指定したDateTimeRangeを優先する
        dateTimeRange &&
        dateTimeRange.considerGuestWorkingHours) {
        periods = periods.and(userPeriodsData.workingHours);
    }
    return periods;
};
//# sourceMappingURL=calcAvailablePeriods.js.map